import { t } from 'i18next'

import { DatepickerHeader } from '~/components/datepicker-header'
import { Filters } from '~/components/Filters'
import HeaderPages from '~/components/HeaderPages'
import PageTitle from '~/components/PageTitle'
import DashboardRetailMediaCampaigns from '~/modules/retailMedia/components/DashboardRetailMediaCampaigns'
import { ImpressionShareNewsAlert } from '~/modules/retailMedia/components/ImpressionShareNewsAlert'
import MainTabs from '~/modules/retailMedia/components/MainTabs'
import RoasCalculationAlerts from '~/modules/retailMedia/components/RoasCalculationAlerts'

import SubPublisherTable from '../../components/_tables/SubPublisherTable'
import { queryFilterListPublishers } from './filters'

import * as S from './styles'

const NetworkDashboard = () => {
  return (
    <>
      <PageTitle title={`Retail Media - ${t('rm:NetworkDashBoard')}`} />

      <HeaderPages
        title={`Retail Media - ${t('rm:NetworkDashBoard')}`}
        className="has-datepicker"
        sideRightComponent={
          <S.WrapperHeader>
            <DatepickerHeader />
          </S.WrapperHeader>
        }
      />

      <MainTabs />

      <ImpressionShareNewsAlert />
      <RoasCalculationAlerts />

      <Filters {...queryFilterListPublishers} />

      <DashboardRetailMediaCampaigns origin="sub_publisher" />

      <SubPublisherTable />
    </>
  )
}

export default NetworkDashboard
